import React from 'react'
import Group from 'components/utils/Group'
import Modal from 'components/Luxkit/Modal/Modal'
import CabinCategoriesModalContent from './CruiseCabinCategoriesModal'

interface Props {
  modalCategories: App.CruiseShipCabinCategory[];
  cabinType: string;
}

function CabinDetailsModal({ cabinType, modalCategories }: Props) {
  return <Modal
    title={`${cabinType} cabins`}
    size="large"
  >
    <Group direction="vertical" gap={24}>
      {modalCategories.map((cabinCategory) => (
        <CabinCategoriesModalContent key={cabinCategory.id} cabinCategory={cabinCategory} />
      ))}
    </Group>
  </Modal>
}

export default CabinDetailsModal
